<template>
    <div class="xx-card-item">
        <div class="xx-card-item-title">
            <div>
                <span>{{ title }}</span>
                <slot name="title"></slot>
            </div>
            <div class="card-item-handle">
                <slot name="operator"></slot>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'XxCardItem',
    props: {
        title: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.xx-card-item {
    .xx-card-item-title {
        font-size: 16px;
        line-height: 20px;
        padding-bottom: 15px;
        color: #333333;
        display: flex;
        .card-item-handle {
            flex: 1;
            text-align: right;
        }
    }
    & + & {
        margin-top: 20px;
    }
}
</style>
